import { tns } from 'tiny-slider/src/tiny-slider';

const DEFAULT_SIZE = 4;

const controls = (() => {
    const div = document.createElement('div');

    div.innerHTML = `<div class="c-controls">
        <button class="c-prev"></button>
        <button class="c-next"></button>
    </div>`;

    return div.firstChild;
})();

const options = {
    autoplayButtonOutput: false,
    controls: true,
    edgePadding: 20,
    gutter: 15,
    items: 1,
    loop: false,
    mouseDrag: true,
    nav: false,
    preventScrollOnTouch: 'auto',
    rewind: true,
    slideBy: 1,
    speed: 600,
    swipeAngle: 30,
};

function init() {
    const elements = document.querySelectorAll('[data-slider="generic-card"]');

    [...elements].forEach((element) => {
        const size = element.dataset.size || DEFAULT_SIZE;

        element.appendChild(controls.cloneNode(true));

        tns({
            ...options,
            container: element.querySelector('.swiper-wrapper'),
            controlsContainer: element.querySelector('.c-controls'),
            responsive: {
                376: {
                    edgePadding: 35,
                    gutter: 20,
                },
                576: {
                    items: Math.floor(1 + size * 0.25),
                    edgePadding: 0,
                },
                768: {
                    items: Math.floor(1 + size * 0.5),
                },
                998: {
                    items: Math.floor(1 + size * 0.75),
                },
                1200: {
                    items: size,
                },
            },
        });
    });
}

export default {
    init,
};
